import { CRUD } from "@/shared/components";
import {
  TranslationsListQuery,
  TranslationShowQuery,
  DeleteTranslationsMutation,
  RestoreTranslationsMutation,
  useTranslationsOptionsQuery,
} from "@/admin/entities/translations";
import { useTranslationsManagement, type TranslationRow } from "../model";
import {
  filterSchema,
  getCreateSchema,
  getEditSchema,
  normalizeTranslationsFilter,
} from "../model/schemas";
import {
  VariantsCell,
  SyncTranslationButton,
  TranslationShowComponent,
} from "@/admin/features/translations";

export function Translations() {
  const { columns, mobileColumns, mapColumns, getTableData, texts } =
    useTranslationsManagement({ VariantsCell, SyncTranslationButton });
  const { data } = useTranslationsOptionsQuery();
  const versionOptions = (data?.translationsOptions ?? []).map((o) => ({
    value: o.value,
    label: o.label,
  }));

  return (
    <CRUD<TranslationRow>
      listQuery={TranslationsListQuery}
      getTableData={getTableData}
      mapColumns={mapColumns}
      columns={columns}
      filterSchema={filterSchema}
      normalizeFilter={normalizeTranslationsFilter}
      createSchema={getCreateSchema(versionOptions)}
      editSchema={getEditSchema(versionOptions, TranslationShowComponent)}
      editQuery={TranslationShowQuery}
      deleteMutation={DeleteTranslationsMutation}
      restoreMutation={RestoreTranslationsMutation}
      texts={texts}
      persistFilters
      useMobileView
      mobileColumns={mobileColumns}
    />
  );
}
